import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, CanActivateChild, ActivatedRouteSnapshot, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

import { PermissionService } from './permission.service';

@Injectable()
export class PermissionGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private readonly permissionService: PermissionService) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkAuth(route.data.permission);
  }

  public canLoad(route: Route): Observable<boolean> {
    return this.checkAuth(route.data.permission);
  }

  public canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkAuth(route.data.permission);
  }

  private checkAuth(permission: string): Observable<boolean> {
    return of(this.permissionService.canActivate(permission));
  }
}
